'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type BlogCardProps = {
  blog: Blog;
  inCarousel?: boolean;
};

export function BlogCard({ blog, inCarousel = false }: BlogCardProps) {
  const locale = useLocaleStore((state) => state.currentLocale);

  let formattedDate;

  try {
    formattedDate = new Date(blog.created_at).toLocaleDateString(locale);
  } catch (error) {
    if (error instanceof RangeError) {
      formattedDate = new Date(blog.created_at).toLocaleDateString('en-US');
    } else {
      throw error;
    }
  }

  return (
    <Link
      prefetch={false}
      href={ROUTES.BLOG_DETAIL({ slug: blog.slug })}
      className={cn(
        'ea-blog-card',
        'col-span-1 flex w-full flex-col items-start justify-start gap-6 rounded-[24px] bg-white p-4 sm:p-5 lg:p-6',
      )}
    >
      <p className="text-sm text-[#707070]">{formattedDate}</p>
      <h3
        data-ea-visual-tag="h5"
        className={cn(
          'line-clamp-3 h-fit text-[22px] font-medium leading-[1.2] sm:line-clamp-2 sm:h-[53px]',
          inCarousel && 'h-[80px]',
        )}
      >
        {blog.name}
      </h3>
      <div className="flex w-full flex-col items-start justify-start gap-4 sm:flex-row sm:flex-wrap sm:items-end sm:justify-between">
        <div
          className={cn(
            'relative flex items-center justify-center gap-2 whitespace-nowrap transition-all hover:opacity-80',
            'ea-contact-card__link',
          )}
        >
          Čítať článok
          <Image
            src={'/images/arrow.svg'}
            alt={'Čítať článok'}
            width={20}
            height={20}
            className="max-h-5 min-h-5 min-w-5 max-w-5 object-contain"
          />
        </div>
        <Image
          src={blog?.image?.url}
          alt={resolveImageAlt(blog?.image, blog?.name)}
          width={0}
          height={0}
          className="h-[237px] w-full rounded-[8px] object-cover object-center sm:h-[183px] sm:max-w-[180px] lg:max-w-[251px]"
          sizes="100vw"
        />
      </div>
    </Link>
  );
}
